import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import Permits from './Permits';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryParms = new URLSearchParams(window.location.search);
const rptType = queryParms.get("rptType");
console.log('RptType: ', rptType);

if (rptType === "Permits"){
  root.render(
    <React.StrictMode>
      <Permits />
    </React.StrictMode>
  );  
}
else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  
}
